import _ from 'lodash'
import React from 'react'
import { CSVLink } from 'react-csv'
import userIsPremium from '../modules/user_is_premium'

function formatData(data) {
  return data.map(row => {
    delete row['Concept Id']
    return row
  })
}

const clickedDownloadBtnClass = "quill-button small contained green focus-on-light"
const unclickedDownloadBtnClass = "quill-button small outlined green focus-on-light"
const printBtnClass = "quill-button small outlined grey focus-on-light"
const printImgClass = "print-img"

export class CSVDownloadForProgressReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userIsPremium: userIsPremium(),
      showDropdown: false
    }
    // Create a ref for the entire component wrapper
    this.wrapperRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('focusin', this.handleFocusIn)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('focusin', this.handleFocusIn)
  }

  // If the click is outside the wrapper, close the dropdown
  handleClickOutside = (e) => {
    const { showDropdown } = this.state
    if (showDropdown && this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ showDropdown: false })
    }
  }

  // If focus moves outside the wrapper, close the dropdown
  handleFocusIn = (e) => {
    const { showDropdown } = this.state
    if (showDropdown && this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ showDropdown: false })
    }
  }

  getRidOfCamelCase(row) {
    const keys = Object.keys(row)
    keys.forEach(oldKey => {
      const newKey = _.startCase(oldKey)
      row[newKey] = row[oldKey]
      delete row[oldKey]
    })
  }

  changeValues(row) {
    const { valuesToChange } = this.props
    valuesToChange.forEach(keyFunction => {
      row[keyFunction.key] = keyFunction.function(row[keyFunction.key])
    })
  }

  formatFilename(studentName) {
    return `concept_results_for_${studentName}`
  }

  cleanData(data) {
    const { keysToOmit, valuesToChange, preserveCasing } = this.props;
    let finalValue
    if (!Array.isArray(data[0])) {
      const copiedData = JSON.parse(JSON.stringify(data))
      let newData = []
      copiedData.forEach(row => {
        if (keysToOmit) {
          row = this.omitKeys(row)
        }
        if (valuesToChange) {
          this.changeValues(row)
        }
        if (!preserveCasing) {
          this.getRidOfCamelCase(row)
        }
        newData.push(row)
      })
      finalValue = newData
    } else {
      finalValue = data
    }
    return formatData(finalValue)
  }

  handleClick() {
    alert('Downloadable reports are a Premium feature. Visit Quill.org/premium to upgrade now!')
  }

  omitKeys(row) {
    const { keysToOmit } = this.props
    return _.omit(row, keysToOmit)
  }

  toggleDropdown = () => {
    this.setState(prevState => ({ showDropdown: !prevState.showDropdown }))
  };

  render() {
    const { userIsPremium, showDropdown } = this.state;
    const { buttonCopy, className, data, studentName } = this.props;
    if (userIsPremium && data) {
      return (
        // Wrap the whole component in a div with the ref.
        <div className='download-button-wrapper' ref={this.wrapperRef}>
          <button className={clickedDownloadBtnClass} onClick={this.toggleDropdown}>
            {buttonCopy || "Download report"}
          </button>
          {showDropdown && (
            <div className='dropdown-content' tabIndex="-1">
              Download report as:
              <span className='pull-right'>
                <div>
                  <i aria-hidden="true" className="fa  fa-caret-up gray-caret" />
                </div>
                <div>
                  <i aria-hidden="true" className="fas fa-caret-up " />
                </div>
              </span>

              <div className='button-wrapper'>
                <button className={printBtnClass} onClick={window.print}>
                  <img
                    alt="print"
                    className={printImgClass}
                    src="https://assets.quill.org/images/icons/download-report-premium.svg"
                  />
                  PDF
                </button>

                <CSVLink
                  className="quill-button csv small outlined grey focus-on-light"
                  data={this.cleanData(data)}
                  filename={this.formatFilename(studentName)}
                  target="_blank"
                >
                  <img alt="csv" src="https://assets.quill.org/images/icons/download-report-premium-csv.svg" />
                  <p>CSV</p>
                </CSVLink>
              </div>
            </div>
          )}
        </div>
      )
    } else {
      return (
        <button
          className={className || unclickedDownloadBtnClass}
          onClick={this.handleClick}
          style={{ display: 'block' }}
        >
          {buttonCopy || "Download report"}
        </button>
      )
    }
  }
}

export default CSVDownloadForProgressReport;
